import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './index.scss'
import Frame from 'MarketPlace/shared/components/Frame'
import { CAPCITO_TERMS } from 'MarketPlace/shared/constants/frameUrls'

import Navigation from 'Navigation/NavigationForIframe'

export default class CapcitoTermsFrameView extends Component {
  static propTypes = {
    t: PropTypes.func,
    selectedCategory: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func
    ])
  }

  render () {
    const { t, selectedCategory } = this.props

    return (
      <Navigation title={t('categories', selectedCategory).s} backLink='/marketplace/capcito/onboarding'>
        <Frame
          className={styles.frame}
          url={CAPCITO_TERMS}
        />
      </Navigation>
    )
  }
}
